import {
  AttachFile,
  InsertEmoticon,
  MoreVert,
  SearchOutlined,
  SignpostOutlined,
} from "@mui/icons-material";
import LogoutIcon from "@mui/icons-material/Logout";
import { Avatar, IconButton } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import React, { useState, useEffect, useRef  } from "react";
import "./Chat.css";
import { auth, db } from "./firebase";
import firebase from 'firebase/compat/app';

function Chat() {
  const [seed, setSeed] = useState("");
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  


  // const messagesEndRef = useRef(null)

  // const scrollToBottom = () => {
  //   messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  // }



  useEffect(() => {
    
    db.collection('messages').orderBy('createdAt').limit(50).onSnapshot(snapshot => {
      setMessages(snapshot.docs.map(doc => doc.data()))
    })
    
    // scrollToBottom()
  }, []);

  const sendMessage = async(e) => {
    e.preventDefault();
    // console.log("you typed - ", input);
    const {uid, photoURL} = auth.currentUser
    
    await db.collection('messages').add({
      text: input,
      photoURL, 
      uid,
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    })
    setInput("");
    
  };


  // function time(params) {
  //   // const {seconds} = params
  //   if(!(params.seconds == null)){

  //     console.log()
  //   }

  // }


  return (
    <div className="chat">
      <div className="chat_header">
        {/* <Avatar src={`https://avatars.dicebear.com/api/human/${seed}.svg`} /> */}
        <div className="chat__headerInfo">
          <h3>CHAT APP</h3>
          <p></p>
        </div>

        <div className="chat__headerRight">
          {/* <IconButton>
            <SearchOutlined />
          </IconButton> */}

          <IconButton>
            <MoreVert />
          </IconButton>

          <div title="Log Out" onClick={() => auth.signOut()}>
            <IconButton>
              <LogoutIcon />
            </IconButton>
          </div>
        </div>
      </div>

      <div className="chat_body">


        {messages.map(({ id, text, photoURL, uid}) => (
          <div key={id}>
            {console.log(uid === auth.currentUser)}
          <div key={id} className={`chat__message ${uid == auth.currentUser.uid && "chat__receiver"}`}>
            {/* <span className="chat__name">maddy</span> */}
            

            <Avatar sx={{ width: 24, height: 24 }} src={photoURL} />
            <div style={{margin: "0 10px"}}>
            {text}

            </div >
            <span className="chat__timestamp">3:30pm </span>
          </div>
          </div>
        ))}
        {/* <div type="text" ref={scrollToBottom} >hello</div> */}

      </div>

      <div className="chat_footer">
        <InsertEmoticon />
        <form>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            type="text"
            placeholder="Type a message"
          />
          <button onClick={sendMessage} type="submit">
            Send a message
          </button>
        </form>
        <MicIcon />
      </div>
    </div>
  );
}

export default Chat;
